import _find from 'lodash/find';
import _some from 'lodash/some';
import _indexOf from 'lodash/indexOf';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import { checkFulfillment } from '../utils/fulfillment-utils';

export const findValidGraphProduct = (bundleItemsList) => {
  const disabledBundleItem = _find(bundleItemsList, (bundleItem) => bundleItem?.bundleDisabled);
  if (!disabledBundleItem) {
    return bundleItemsList?.[0]?.item || bundleItemsList?.[0];
  }

  return disabledBundleItem?.item;
};

export const checkFulfillmentStatus = (choiceId, sku, productData, zipCode, disabled, choices) => {
  const graphProduct = productData?.[sku];
  const promoType = graphProduct?.pricing?.conditionalPromotions?.[0]?.promotionTags?.[0] || null;
  const fulfillmentInfo = checkFulfillment(graphProduct, zipCode);
  const inExcludedShipState = (
        fulfillmentInfo?.pickup?.inExcludedShipState
        || fulfillmentInfo?.delivery?.inExcludedShipState
  );

  const isAvailable = graphProduct
    ? _some(
      fulfillmentInfo,
      (info) => _some(
            info?.services,
            (service) => service.fulfillable === true
      )
    )
    : false;

  const isDisabled = disabled ? _indexOf(disabled, choiceId) !== -1 : false;
  const allDisabled = isDisabled || !isAvailable;

  return {
    id: choiceId,
    mediaUrl: choices?.[choiceId]?.mediaUrl,
    shortLabel: choices?.[choiceId]?.shortLabel,
    internalName: choices?.[choiceId]?.internalName,
    sku,
    inExcludedShipState,
    promoType,
    disabled: allDisabled,
    isAvailable,
  };
};

export const getEnhancedChoicesMobile = ({
  index, options, metadata, productData, zipCode, disabled, choices, bundles = null
}) => _map(options?.[index]?.choices, (choiceId) => {
  const { Sku: sku, BundleDesign: bundleDesign } = metadata?.[choiceId]?.metadata;
  // CODE SMELL: copy pasta carbs
  if (bundles?.[bundleDesign]?.bundleSkus) {
    const bundleItemsList = _map(
      bundles[bundleDesign].bundleSkus,
      (itemId) => {
        const fulfillmentStatus = checkFulfillmentStatus(choiceId, itemId, productData, zipCode, disabled, choices);
        if (fulfillmentStatus?.disabled) {
          return { bundleDisabled: true, item: fulfillmentStatus };
        }

        return fulfillmentStatus;
      }
    );

    return findValidGraphProduct(bundleItemsList);
  }
  return checkFulfillmentStatus(choiceId, sku, productData, zipCode, disabled, choices);
});

export const getEnhancedChoices = ({
  option, metadata, productData, zipCode, disabled, choices, bundles = null
}) => _map(option.choices, (choiceId) => {
  const { Sku: sku, BundleDesign: bundleDesign } = metadata?.[choiceId]?.metadata;
  // CODE SMELL: copy pasta carbs
  if (bundles?.[bundleDesign]?.bundleSkus) {
    const bundleItemsList = _map(
      bundles[bundleDesign].bundleSkus,
      (itemId) => {
        const fulfillmentStatus = checkFulfillmentStatus(choiceId, itemId, productData, zipCode, disabled, choices);
        if (fulfillmentStatus?.disabled) {
          return { bundleDisabled: true, item: fulfillmentStatus };
        }

        return fulfillmentStatus;
      }
    );

    return findValidGraphProduct(bundleItemsList);
  }

  return checkFulfillmentStatus(choiceId, sku, productData, zipCode, disabled, choices);

});
